<template>
  <div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full mb-3">
        <vs-button
          type="button"
          class="mx-4"
          style="background-color:#444"
          @click.prevent="backToCurrentGrid()"
          >{{ $t("Back") }}</vs-button
        >
        <vs-button
          v-if="allInformationPackage.state < 3"
          type="gradient"
          color="danger"
          class="float-right"
          @click.prevent="RejectPackage()"
          v-has-permission="permission498"
          >{{ $t("RejectPackage") }}</vs-button
        >
      </div>
      <state
        :allInformationPackage="allInformationPackage"
        :isShowBtnReceipt="isShowBtnReceipt"
        @ShowAttachFilePopup="ShowAttachFilePopup"
      ></state>
    </div>
    <div class="vx-row mt-8">
      <div class="vx-card__body w-1/2 px-6">
        <package-info
          :allInformationPackage="allInformationPackage"
        ></package-info>
      </div>
      <div class="vx-card__body w-1/2">
        <div class="vx-card vx-col w-full p-4 pb-12">
          <div class="vx-row px-4">
            <div class="w-1/3"></div>
            <div class="text-center w-1/3">
              <h4 class="pb-4">{{ $t("ProductsList") }}</h4>
            </div>

            <div class="w-1/3">
              <vs-button
                type="gradient"
                icon-pack="feather"
                class="py-2 mb-2 float-right bg_purple"
                @click="exportExcelAllSerial()"
              >
                {{ $t("GetListExcelAllSerial") }}
              </vs-button>
            </div>
          </div>

          <table class="basic-tbl">
            <thead>
              <tr>
                <th style="width: 12%; color: black">
                  {{ $t("PackageCount") }}
                </th>
                <th style="width: 13%; color: black">{{ $t("ItemCode") }}</th>
                <th style="width: 40%; color: black">
                  {{ $t("ProductName") }}
                </th>
                <th style="width: 35%; color: black">
                  {{ $t("GetListExcelSerial") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(PackageInfo, index) in PackagesInfo" :key="index">
                <td style="width: 12%">
                  {{ PackageInfo.count ? PackageInfo.count : "---" }}
                </td>
                <td style="width: 13%">{{ PackageInfo.itemCode }}</td>
                <td style="width: 40%">
                  {{ PackageInfo.productName }}
                </td>
                <td style="width: 35%">
                  <vs-button
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    class="py-1 mx-auto"
                    @click="exportExcelSerial(PackageInfo.itemCode)"
                  >
                    {{ $t("GetListExcelSerial") }}
                  </vs-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div>
      <vs-button
        color="success"
        v-if="allInformationPackage.state == 3"
        type="gradient"
        icon-pack="feather"
        class="bordered-btn px-8 py-3 float-right"
        @click="ConfirmPackage()"
        v-has-permission="permission298"
      >
        {{ $t("ConfirmDelivered") }}
      </vs-button>
      <!-- <vs-button
        color="success"
        v-if="allInformationPackage.state == 1"
        type="gradient"
        icon-pack="feather"
        class="bordered-btn px-8 py-3 float-right"
        @click="approvedToOperatorMet()"
      >
        دریافت اپراتور
      </vs-button> -->
    </div>
    <receipt-image-popup
      :show="onShowReceiptImagePopup"
      :PackagereceiptImageInfo="PackagereceiptImageInfo"
      :packageId="packageId"
      @finish="finishWithoutRenderReceiptImagePopup"
    ></receipt-image-popup>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ReceiptImagePopup from "./ReceiptImagePopup.vue";
import PackageInfo from "./PartialDetails/PackageInfo.vue";
import State from "./PartialDetails/State.vue";
export default {
  props: {},
  data() {
    return {
      referencePageInfo: this.$route,
      permission298: "ChangePackageStateToFinished",
      permission498: "ChangePackageStateToReject",
      allInformationPackage: {},
      packageId: "",
      onShowReceiptImagePopup: false,
      isShowBtnReceipt: true,
      PackagereceiptImageInfo: "",
      PackagesInfo: {},
      model: {},
      modelForExportExcel: {}
    };
  },
  components: {
    ReceiptImagePopup,
    PackageInfo,
    State
  },
  computed: {
    ...mapGetters({
      PackageInfoDetails: "identityAccess/PackageInfoDetails"
    })
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchPackageInfo: "identityAccess/fetchPackageInfo",
      // approvedToOperator: "identityAccess/approvedToOperator",
      deliverdPackageFinish: "identityAccess/deliverdPackageFinish",
      exportExcelSerialWithItemCode: "excel/exportExcelSerialWithItemCode",
      packageReject: "identityAccess/packageReject",
      exportExcelAllSerialWithItemCode: "excel/exportExcelAllSerialWithItemCode"
    }),
    async load() {
      var id = this.$route.params.id;
      await this.fetchPackageInfo(id).then(r => {
        this.allInformationPackage = r;
        this.PackagesInfo = r.packageItems;
        if (this.allInformationPackage.receiptImage) {
          this.isShowBtnReceipt = false;
        }
      });
    },
    // approvedToOperatorMet() {
    //   this.model.packageId = this.allInformationPackage.id;
    //   this.approvedToOperator(this.model).then(() => {
    //     this.$swal({
    //       position: "center-center",
    //       type: "success",
    //       text: "تحویل مرسوله به اپراتور تایید شد.",
    //       showConfirmButton: false,
    //       timer: 2000
    //     });
    //   });
    // },
    ConfirmPackage() {
      this.model.packageId = this.allInformationPackage.id;
      this.deliverdPackageFinish(this.model).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "تحویل مرسوله موردنظر با موفقیت تایید شد.",
          showConfirmButton: false,
          timer: 2000
        });
      });
    },
    RejectPackage() {
      this.$swal({
        title: "آیا از رد این مرسوله اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر"
      }).then(result => {
        if (result.value) {
          this.model.packageId = this.allInformationPackage.id;
          this.packageReject(this.model).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "مرسوله مورد‌نظر با موفقیت رد شد!",
              showConfirmButton: false,
              timer: 2000
            });
            this.backToCurrentGrid();
          });
        }
      });
    },
    exportExcelAllSerial() {
      this.exportExcelAllSerialWithItemCode(this.allInformationPackage.id)
        .then()
        .catch(() => {});
    },
    exportExcelSerial(itemCode) {
      this.modelForExportExcel = {
        packageId: this.allInformationPackage.id,
        itemCode: itemCode
      };
      this.exportExcelSerialWithItemCode(this.modelForExportExcel);
    },
    ShowAttachFilePopup(PackagereceiptImageInfo) {
      this.packageId = this.allInformationPackage.id;
      this.onShowReceiptImagePopup = true;
      this.PackagereceiptImageInfo = PackagereceiptImageInfo;
    },
    finishWithoutRenderReceiptImagePopup() {
      this.onShowReceiptImagePopup = false;
    },
    backToCurrentGrid() {
      this.$router.push({
        path: "/Package/Index",
        query: {
          referencePageInfo: {
            gridSearchData: this.$route.query.gridSearchData,
            numberRowsPerPage: this.$route.query.numberRowsPerPage,
            tabIndex: this.$route.params.tabIndex
          }
        }
      });
    }
  }
};
</script>
